(function () {

  function parseSize(v) {
    var m = v.match(/([0-9]+)[ ]*ml/i);
    return m ? m[1] + 'ml' : v;
  }

  function parseSprays(v) {
    var m = v.match(/([0-9]+)[–-]([0-9]+)[ ]*sprays/i);
    if (m) return m[1] + '–' + m[2] + ' sprays';
    var s = v.match(/([0-9]+)[ ]*sprays/i);
    return s ? s[1] + ' sprays' : null;
  }

  function formatPrice(cents) {
    var dollars = cents / 100;
    return '$' + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
  }

  function getVariantPrices(callback) {
    // First try: find embedded product JSON in the page
    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var data = JSON.parse(scripts[i].textContent);
        if (data && data.variants && data.variants.length) {
          var map = {};
          data.variants.forEach(function (v) { map[v.id] = v.price; });
          return callback(map);
        }
      } catch (e) {}
    }

    // Fallback: fetch from Shopify product JSON endpoint
    var match = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
    if (!match) return callback({});

    fetch('/products/' + match[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var map = {};
        if (data && data.variants) {
          data.variants.forEach(function (v) { map[v.id] = v.price; });
        }
        callback(map);
      })
      .catch(function () { callback({}); });
  }

  function buildTiles(priceMap) {
    var triggers = document.querySelectorAll('button.select[aria-controls*="popover-variant-dropdown"]');

    triggers.forEach(function (btn) {
      if (btn.dataset.tilesBuilt) return;

      var popoverId = btn.getAttribute('aria-controls');
      var popover = document.getElementById(popoverId);
      if (!popover) return;

      var labels = popover.querySelectorAll('label.popover__value-option');
      if (!labels.length) return;

      btn.dataset.tilesBuilt = '1';

      var grid = document.createElement('div');
      grid.className = 'variant-tile-grid';

      labels.forEach(function (label) {
        var radioId = label.getAttribute('for');
        var radio = radioId ? document.getElementById(radioId) : null;
        var variantId = radio ? parseInt(radio.value, 10) : null;
        var value = label.textContent.trim();

        var tile = document.createElement('button');
        tile.type = 'button';
        tile.className = 'variant-tile';
        if (radio && radio.checked) tile.classList.add('is-selected');

        var isPopular = /10[ ]*ml/i.test(value);
        if (isPopular) {
          var badge = document.createElement('span');
          badge.className = 'variant-tile__badge';
          badge.textContent = 'Popular';
          tile.appendChild(badge);
        }

        var sizeSpan = document.createElement('span');
        sizeSpan.className = 'variant-tile__size';
        sizeSpan.textContent = parseSize(value);
        tile.appendChild(sizeSpan);

        var sprays = parseSprays(value);
        if (sprays) {
          var spraysSpan = document.createElement('span');
          spraysSpan.className = 'variant-tile__sprays';
          spraysSpan.textContent = sprays;
          tile.appendChild(spraysSpan);
        }

        if (variantId && priceMap[variantId] !== undefined) {
          var priceSpan = document.createElement('span');
          priceSpan.className = 'variant-tile__price';
          priceSpan.textContent = formatPrice(priceMap[variantId]);
          tile.appendChild(priceSpan);
        }

        tile.addEventListener('click', function () {
          label.click();
          grid.querySelectorAll('.variant-tile').forEach(function (t) {
            t.classList.remove('is-selected');
          });
          tile.classList.add('is-selected');
        });

        grid.appendChild(tile);
      });

      btn.parentElement.insertBefore(grid, btn);
      btn.style.setProperty('display', 'none', 'important');
      popover.style.setProperty('display', 'none', 'important');

      document.addEventListener('variant:changed', function () {
        var allTiles = grid.querySelectorAll('.variant-tile');
        labels.forEach(function (label, i) {
          var r = document.getElementById(label.getAttribute('for'));
          if (allTiles[i]) allTiles[i].classList.toggle('is-selected', !!(r && r.checked));
        });
      });
    });
  }

  // Get prices first, then build tiles
  getVariantPrices(function (priceMap) {
    buildTiles(priceMap);
    setTimeout(function () { buildTiles(priceMap); }, 200);
    setTimeout(function () { buildTiles(priceMap); }, 600);

    new MutationObserver(function () {
      buildTiles(priceMap);
    }).observe(document.body, { childList: true, subtree: true });
  });
// Move savings badge inline with price
  function moveSavings() {
    var savings = document.querySelector('.aromatick-savings');
    var priceList = document.querySelector('.price-list--product');
    if (savings && priceList && !priceList.contains(savings)) {
      priceList.appendChild(savings);
    }
  }

  moveSavings();
  setTimeout(moveSavings, 300);
})();